import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal modal-share-testimony",
  ref: "modal"
}
const _hoisted_2 = { class: "modal__content" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "screen-reader" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "memorial-share-testimony" }
const _hoisted_7 = {
  key: 0,
  class: "memorial-share-testimony__intro step_record_or_not group-fade"
}
const _hoisted_8 = { class: "center-text" }
const _hoisted_9 = { class: "memorial-share-testimony__intro__title" }
const _hoisted_10 = { class: "memorial-share-testimony__intro__sub-title" }
const _hoisted_11 = { class: "nav" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "align-right" }
const _hoisted_15 = {
  key: 0,
  class: "memorial-share-testimony__choice step_audio-text-choice group-fade"
}
const _hoisted_16 = { class: "memorial-share-testimony__choice__title center-text" }
const _hoisted_17 = { class: "nav" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "200px",
    height: "298px",
    viewBox: "0 0 200 298",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Group-5",
        transform: "translate(-0.000018, 1.000000)"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M158.711018,97.187 C158.711018,194.374 132.368018,194.374 99.8715181,194.374 C67.3755181,194.374 41.0325181,194.374 41.0325181,97.187 C41.0325181,0 67.3755181,0 99.8715181,0 C132.368018,0 158.711018,0 158.711018,97.187",
          id: "Fill-1",
          fill: "#336E5A"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M158.711018,97.187 C158.711018,194.374 132.368018,194.374 99.8715181,194.374 C67.3755181,194.374 41.0325181,194.374 41.0325181,97.187 C41.0325181,0 67.3755181,0 99.8715181,0 C132.368018,0 158.711018,0 158.711018,97.187 Z",
          id: "Stroke-2",
          stroke: "#336E5A"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M4.90599171,133.656982 C7.66692715,133.605955 9.94720459,135.802038 9.99913394,138.562974 C10.9840899,190.930275 51.0639927,233.375785 99.3337485,233.577903 C147.734247,233.778577 188.17993,191.439535 189.353266,138.936288 C189.414963,136.175554 191.702995,133.987552 194.46373,134.049248 C197.224464,134.110945 199.412467,136.398977 199.352043,139.159712 C198.059064,196.959605 153.311617,243.801788 99.2920819,243.578616 C45.4228975,243.352251 1.08515389,196.397593 0,138.751026 C-0.0510270574,135.990091 2.14505628,133.709814 4.90599171,133.656982 Z",
          id: "Path",
          fill: "#336E5A",
          "fill-rule": "nonzero"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M99.6763181,233.577 C102.365073,233.577 104.558136,235.699307 104.671699,238.36011 L104.676318,238.577 L104.676318,291.659 C104.676318,294.420424 102.437742,296.659 99.6763181,296.659 C96.9875634,296.659 94.7945,294.536693 94.6809376,291.87589 L94.6763181,291.659 L94.6763181,238.577 C94.6763181,235.815576 96.9148944,233.577 99.6763181,233.577 Z",
          id: "Path",
          fill: "#336E5A",
          "fill-rule": "nonzero"
        })
      ])
    ])
  ])
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "291px",
    height: "244px",
    viewBox: "0 0 291 244",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Page-1",
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("g", {
        id: "Group-4",
        transform: "translate(0.481237, 0.000000)",
        fill: "#336E5A"
      }, [
        /*#__PURE__*/_createElementVNode("polygon", {
          id: "Fill-1",
          points: "140.790084 230.7001 145.508084 195.8611 274.792084 0 289.958084 10.343 169.822084 210.8771"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M18.5240398,170.72393 L19.019363,171.332973 L19.5188868,171.969419 L20.0227883,172.632952 L20.5312445,173.323258 C20.6163766,173.440523 20.7017058,173.55889 20.7872359,173.678353 L21.3028561,174.40823 C21.3892044,174.53205 21.4757608,174.656954 21.5625292,174.782933 L22.0857118,175.551674 L22.6141573,176.34593 L23.1480429,177.165389 C25.0269731,180.078167 26.9000141,183.322625 28.7387351,186.766286 L29.5163397,188.236681 C29.8862567,188.943499 30.2325084,189.616429 30.5760772,190.294527 L31.2658546,191.669189 L31.9857796,193.127072 C32.2871605,193.741034 32.5818056,194.353008 32.87444,194.972632 L33.458428,196.224935 C33.6531303,196.647673 33.848339,197.076665 34.045454,197.514769 L34.643918,198.859266 L35.4329279,200.670773 L38.4036293,207.615777 L39.7194229,210.642555 L40.5706211,212.562356 L41.3710247,214.32805 L41.8353588,215.331007 L42.4450366,216.621276 L42.7487652,217.252327 L43.1387626,218.051 L43.151169,218.031534 C47.2745849,211.204898 50.9022697,203.586575 53.8822342,194.822535 L54.2231931,193.806195 L58.9699742,195.377205 C55.5691344,205.652792 51.3148013,214.442047 46.4292214,222.245727 L45.8077626,223.225 L46.4926828,224.496748 L47.7711266,226.834872 L48.4465293,228.045495 L49.0884366,229.169884 L49.4991761,229.87319 C49.5665449,229.98739 49.6333815,230.100094 49.6997035,230.211323 L50.0916023,230.861156 L50.471998,231.476557 L50.8417366,232.0585 L51.2016641,232.607958 L51.5526263,233.125906 L51.8954692,233.613316 L52.2310389,234.071162 C52.286408,234.145061 52.3415094,234.217768 52.3963605,234.289304 L52.7226063,234.70463 C52.7765272,234.771564 52.8302332,234.837367 52.8837419,234.902059 L53.2025672,235.277057 L53.517503,235.626386 L53.8293952,235.95102 C55.0720048,237.201463 56.261871,237.88259 57.6426268,238.274819 C58.6468448,238.560041 59.5490113,238.625533 60.4929709,238.498077 L60.8520593,238.441287 C61.4565137,238.331761 62.0964863,238.145952 62.8567173,237.855322 L63.3279648,237.668137 L63.832142,237.454426 C63.9191416,237.416521 64.0076828,237.377453 64.0978502,237.337195 L64.6590483,237.081126 L65.2633448,236.795105 L66.0268003,236.42223 L69.8328283,234.521513 C71.577649,233.664861 73.1636718,232.929804 74.8504467,232.210845 L76.2348482,231.626253 C78.6774586,230.606066 80.6591494,229.847551 83.2376587,228.988702 C92.1389245,226.02387 100.914954,224.553396 109.247576,225.346016 C109.708441,225.389854 110.166599,225.440731 110.621538,225.498682 C118.213955,226.464425 126.01208,229.451666 134.172542,235.751713 L134.717111,236.176638 L131.621056,240.102762 C124.014451,234.10436 116.892066,231.336569 109.99018,230.458661 C109.587767,230.4074 109.182388,230.362385 108.774101,230.323547 C101.242015,229.607077 93.1151001,230.968787 84.8177153,233.732479 C82.959548,234.351397 81.4259982,234.916227 79.7675741,235.581691 L78.6385255,236.04194 L77.4428809,236.542193 C77.2364129,236.629469 77.0259369,236.718835 76.8108363,236.810505 C75.4419108,237.393986 74.1389372,237.990582 72.7429119,238.665474 L71.6074602,239.221956 L68.1256863,240.962406 L67.3563684,241.336724 L66.6352841,241.676538 L65.9570535,241.983258 C64.0910278,242.806742 62.6762436,243.248658 61.1620133,243.453114 C59.5348584,243.672816 57.9399768,243.557036 56.2764404,243.084552 C52.7198671,242.074241 50.2478464,240.104848 47.3103996,235.78217 L46.8874308,235.148485 C46.8163525,235.040152 46.7449685,234.930448 46.6732579,234.819354 L46.2389078,234.135949 C46.0927064,233.902485 45.9450312,233.663308 45.7957148,233.418269 L45.3426748,232.665409 L44.6424549,231.468184 L44.160404,230.623426 L43.6649914,229.740327 L42.9132843,228.376886 L42.6567626,227.907 L42.4545942,228.191279 C42.1401327,228.629917 41.8296539,229.05489 41.5229864,229.466511 L40.9146821,230.272042 C40.713574,230.534679 40.514109,230.791475 40.3162363,231.042522 L39.7273445,231.77851 C34.6641355,238.0092 30.6430044,240.416258 26.771426,240.628833 L26.5619518,240.638208 C21.9240398,240.798531 18.6838773,238.947938 14.2190718,234.816385 L13.5035431,234.14504 C6.53527878,227.523968 2.56361691,218.643709 0.908222016,208.167521 C-0.166229313,201.367842 -0.191318875,195.793582 0.335320748,187.999722 L0.507367053,185.587027 L0.65317166,183.69537 L0.760900925,182.409811 L0.869427554,181.223783 L0.980722119,180.124124 L1.0967552,179.09767 L1.17771621,178.447537 L1.26224291,177.82019 L1.35091917,177.211727 L1.44432887,176.61825 L1.59459583,175.7476 L1.70239357,175.174522 L1.8169683,174.602779 L1.87697949,174.316189 C1.95700494,173.939306 2.0404104,173.572536 2.12751731,173.216065 L2.30676163,172.516908 C3.44371041,168.290802 5.17628743,165.650089 8.10753078,164.943362 C11.4642971,164.13391 14.8244252,166.259645 18.5240398,170.72393 Z M9.27954676,169.804059 C8.59688527,169.96865 7.9971833,170.868853 7.47152261,172.513791 L7.3416448,172.940546 L7.21482108,173.398364 C7.19393658,173.477257 7.17317804,173.557446 7.15254482,173.638931 L7.03024417,174.143401 L6.91092019,174.679013 L6.79454192,175.245798 L6.68107838,175.843788 L6.57049862,176.473015 L6.46277166,177.13351 L6.35786655,177.825305 L6.25575231,178.548431 L6.1077461,179.691937 L6.01247357,180.493531 L5.87458477,181.754887 L5.74262708,183.087095 L5.61649597,184.490263 L5.53559394,185.465183 L5.38129547,187.509904 C4.82070806,195.398778 4.80857462,200.815787 5.8469453,207.387129 C7.34400753,216.861306 10.8703588,224.745893 16.947762,230.520491 L17.6041558,231.136045 L18.2342162,231.709059 L18.8402976,232.240191 C21.7155352,234.707173 23.8330154,235.729555 26.3890601,235.641198 L26.5311641,235.634405 L26.8188092,235.60923 L27.1112792,235.568046 C28.4386864,235.345705 29.9214832,234.616949 31.6789107,233.109499 L32.0740192,232.761581 C32.4071244,232.460784 32.7499505,232.132591 33.1032548,231.775273 L33.5322981,231.3324 C33.6046597,231.256221 33.6774525,231.178849 33.7506827,231.100271 L34.1953598,230.614214 L34.650823,230.098537 L35.117363,229.552575 C35.1960589,229.459021 35.2752284,229.364178 35.3548777,229.268031 L35.8385782,228.675399 C35.9201706,228.573983 36.0022547,228.471236 36.0848367,228.367145 L36.5863521,227.726348 L37.1001074,227.052611 L37.6263935,226.34527 L38.1655012,225.603661 C38.2564371,225.477167 38.3479193,225.349218 38.439954,225.219799 L38.9988393,224.425544 L39.5712731,223.59536 L40.0087626,222.947 L40.0030668,222.935865 C39.7583197,222.462382 39.5201773,221.996188 39.286362,221.532584 L38.6362566,220.227516 L38.1871464,219.306241 L37.4406434,217.738022 L36.834743,216.432269 L35.8894987,214.343146 L34.8725536,212.03958 L33.3505932,208.522093 L31.0137659,203.050773 L30.3695192,201.56202 L29.7787952,200.221335 L29.2044534,198.944684 C28.7303742,197.902806 28.2647835,196.910066 27.7862405,195.922559 L27.4973889,195.330331 C27.2533445,194.833174 27.0205208,194.361353 26.7928125,193.903494 L26.1189279,192.560423 C25.783553,191.898454 25.4459501,191.242303 25.0855132,190.553578 L24.3280885,189.121323 C22.5493036,185.789913 20.742264,182.659782 18.9463745,179.875736 C16.7646733,176.493592 14.7161691,173.809588 12.8948649,172.021693 C12.7560637,171.885438 12.6200786,171.755888 12.4870476,171.632914 L12.0969553,171.283591 C10.7636173,170.129114 9.77119899,169.685502 9.27954676,169.804059 Z",
          id: "Stroke-3",
          "fill-rule": "nonzero"
        })
      ])
    ])
  ])
], -1)
const _hoisted_20 = {
  key: 0,
  class: "memorial-share-testimony__text group-fade"
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "textarea__wrapper" }
const _hoisted_23 = {
  class: "textarea__wrapper__bar-wrapper",
  ref: "textareaBars",
  "aria-hidden": "true"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "bar" }, " ", -1)
const _hoisted_35 = [
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "words-count" }
const _hoisted_37 = { class: "nav" }
const _hoisted_38 = { class: "align-right" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "memorial-share-testimony__voice group-fade"
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 2,
  class: "record-actions"
}
const _hoisted_43 = {
  key: 0,
  class: "circular"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "bar left" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "bar right" }, null, -1)
const _hoisted_46 = { class: "counter" }
const _hoisted_47 = {
  key: 1,
  class: "text"
}
const _hoisted_48 = {
  key: 2,
  class: "text"
}
const _hoisted_49 = {
  key: 0,
  class: "nav"
}
const _hoisted_50 = {
  key: 0,
  class: "memorial-share-testimony__voice group-fade"
}
const _hoisted_51 = { class: "center-text" }
const _hoisted_52 = { class: "nav" }
const _hoisted_53 = {
  key: 0,
  class: "memorial-share-testimony__sign group-fade"
}
const _hoisted_54 = { class: "split" }
const _hoisted_55 = { class: "col make-anonymous-checkbox" }
const _hoisted_56 = { class: "input-container" }
const _hoisted_57 = { class: "input-checkbox" }
const _hoisted_58 = { for: "makeAnonymous" }
const _hoisted_59 = { class: "col make-anonymous-name" }
const _hoisted_60 = { class: "input-container" }
const _hoisted_61 = {
  for: "firstName",
  class: "screen-reader"
}
const _hoisted_62 = ["disabled", "placeholder"]
const _hoisted_63 = { class: "split no-desktop" }
const _hoisted_64 = { class: "col" }
const _hoisted_65 = { class: "input-container" }
const _hoisted_66 = {
  for: "city",
  class: "screen-reader"
}
const _hoisted_67 = ["placeholder"]
const _hoisted_68 = { class: "col" }
const _hoisted_69 = { class: "input-container" }
const _hoisted_70 = {
  for: "email",
  class: "screen-reader"
}
const _hoisted_71 = ["placeholder"]
const _hoisted_72 = {
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_73 = { class: "make-public center-text" }
const _hoisted_74 = { class: "input-container" }
const _hoisted_75 = { class: "input-checkbox" }
const _hoisted_76 = { for: "yes" }
const _hoisted_77 = {
  class: "invalid-feedback",
  role: "alert"
}
const _hoisted_78 = { class: "nav" }
const _hoisted_79 = { class: "legal-container" }
const _hoisted_80 = { class: "align-right wrapper-btn-submit" }
const _hoisted_81 = {
  key: 1,
  class: "upload-progress",
  ref: "uploadProgress"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_83 = {
  key: 0,
  class: "memorial-share-testimony__confirmation group-fade"
}
const _hoisted_84 = { class: "center-text" }
const _hoisted_85 = { class: "nav" }
const _hoisted_86 = { class: "align-center" }
const _hoisted_87 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SoundWave = _resolveComponent("SoundWave")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.display)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.showExit)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    role: "button",
                    class: "close",
                    title: _ctx.btnCloseTitle,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
                  }, [
                    _withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [
                      [_directive_translate, `general.modal_close`]
                    ])
                  ], 8, _hoisted_3))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'intro')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                                [_directive_translate, `testimonial.title`]
                              ]),
                              _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                                [_directive_translate, `testimonial.subtitle`]
                              ])
                            ]),
                            _createElementVNode("ul", _hoisted_11, [
                              (_ctx.remainingThemes > 0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                    _withDirectives(_createElementVNode("button", {
                                      role: "button",
                                      type: "button",
                                      class: "btn-big",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.notNow()))
                                    }, null, 512), [
                                      [_directive_translate, `testimonial.not_now`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.remainingThemes === 0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                    _withDirectives(_createElementVNode("button", {
                                      role: "button",
                                      type: "button",
                                      class: "btn-big",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.finish()))
                                    }, null, 512), [
                                      [_directive_translate, `testimonial.end_now`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", _hoisted_14, [
                                _withDirectives(_createElementVNode("button", {
                                  role: "button",
                                  type: "button",
                                  class: "btn-big",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.choice()))
                                }, null, 512), [
                                  [_directive_translate, `testimonial.give_my_testimonial`]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'choice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
                              [_directive_translate, `testimonial.write_or_voice_message`]
                            ]),
                            _createElementVNode("ul", _hoisted_17, [
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  role: "button",
                                  type: "button",
                                  class: "btn-big",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.voice()))
                                }, [
                                  _hoisted_18,
                                  _withDirectives(_createElementVNode("span", null, null, 512), [
                                    [_directive_translate, `testimonial.orally`]
                                  ])
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                  role: "button",
                                  type: "button",
                                  class: "btn-big",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.text()))
                                }, [
                                  _hoisted_19,
                                  _withDirectives(_createElementVNode("span", null, null, 512), [
                                    [_directive_translate, `testimonial.written`]
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", {
                              ref: "panelsText",
                              class: "panels",
                              style: _normalizeStyle('height:' + _ctx.panelHeight + 'px; flex: 0 0 ' + _ctx.panelHeight + 'px')
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panels, (panel, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass([{ visible: _ctx.panelIndex === index }, "panel"])
                                  }, [
                                    _createElementVNode("h3", {
                                      innerHTML: panel.content
                                    }, null, 8, _hoisted_21)
                                  ], 2)
                                ]))
                              }), 128))
                            ], 4),
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("textarea", {
                                rows: "4",
                                cols: "50",
                                maxlength: "1500",
                                ref: "textareaText",
                                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.textareaBarDisapear())),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.text) = $event))
                              }, null, 544), [
                                [_vModelText, _ctx.form.text]
                              ]),
                              _createElementVNode("div", _hoisted_23, _hoisted_35, 512)
                            ]),
                            _createElementVNode("p", _hoisted_36, [
                              _createTextVNode(_toDisplayString(_ctx.textLength) + " ", 1),
                              _withDirectives(_createElementVNode("span", null, null, 512), [
                                [_directive_translate, `testimonial.word_count`]
                              ])
                            ]),
                            _createElementVNode("ul", _hoisted_37, [
                              _createElementVNode("li", _hoisted_38, [
                                _withDirectives(_createElementVNode("button", {
                                  role: "button",
                                  type: "button",
                                  class: "btn-big",
                                  title: "Signer mon témoinage",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sign())),
                                  disabled: !_ctx.form.text
                                }, null, 8, _hoisted_39), [
                                  [_directive_translate, `testimonial.sign`]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'voice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_ctx.stream)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  ref: "panelsText",
                                  class: "panels",
                                  style: _normalizeStyle('height:' + _ctx.panelHeight + 'px; flex: 0 0 ' + _ctx.panelHeight + 'px')
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panels, (panel, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass([{ visible: _ctx.panelIndex === index }, "panel"])
                                      }, [
                                        _createElementVNode("h3", {
                                          innerHTML: panel.content
                                        }, null, 8, _hoisted_41)
                                      ], 2)
                                    ]))
                                  }), 128))
                                ], 4))
                              : _createCommentVNode("", true),
                            _createVNode(_component_SoundWave, { ref: "soundwave" }, null, 512),
                            (!_ctx.stream)
                              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  role: "button",
                                  type: "button",
                                  class: "btn-big btn-authorize",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.requestVoiceAccess()))
                                }, null, 512)), [
                                  [_directive_translate, `permissions.authorize_microphone`]
                                ])
                              : _createCommentVNode("", true),
                            (_ctx.stream)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _withDirectives(_createElementVNode("button", {
                                    role: "button",
                                    type: "button",
                                    class: "btn-record",
                                    ref: "recordBtn",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleRecord()))
                                  }, [
                                    (true || !_ctx.circular)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["circle", { animate: _ctx.recording }])
                                          }, [
                                            _hoisted_44,
                                            _hoisted_45,
                                            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.remainingTime), 1)
                                          ], 2)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (!_ctx.recording)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_47, null, 512)), [
                                          [_directive_translate, `testimonial.start_recording`]
                                        ])
                                      : _createCommentVNode("", true),
                                    (_ctx.recording)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_48, null, 512)), [
                                          [_directive_translate, `testimonial.stop_recording`]
                                        ])
                                      : _createCommentVNode("", true)
                                  ], 512), [
                                    [_vShow, !_ctx.audioUrl]
                                  ]),
                                  (_ctx.audioUrl)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_49, [
                                        _createElementVNode("li", null, [
                                          _withDirectives(_createElementVNode("button", {
                                            role: "button",
                                            type: "button",
                                            class: "btn-big",
                                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetRecord()))
                                          }, null, 512), [
                                            [_directive_translate, `testimonial.re-recording`]
                                          ])
                                        ]),
                                        _createElementVNode("li", null, [
                                          _withDirectives(_createElementVNode("button", {
                                            role: "button",
                                            type: "button",
                                            class: "btn-big",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sign()))
                                          }, null, 512), [
                                            [_directive_translate, `testimonial.sign`]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'voiceQuit')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _withDirectives(_createElementVNode("h2", null, null, 512), [
                                [_directive_translate, `testimonial.close_window`]
                              ])
                            ]),
                            _createElementVNode("ul", _hoisted_52, [
                              _createElementVNode("li", null, [
                                _withDirectives(_createElementVNode("button", {
                                  role: "button",
                                  type: "button",
                                  class: "btn-big",
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.step = 'voice'))
                                }, null, 512), [
                                  [_directive_translate, `testimonial.close_window_button_back`]
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _withDirectives(_createElementVNode("button", {
                                  role: "button",
                                  type: "button",
                                  class: "btn-big",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.close()))
                                }, null, 512), [
                                  [_directive_translate, `testimonial.close_window_button_go`]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'sign')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("div", _hoisted_57, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      id: "makeAnonymous",
                                      class: "screen-reader",
                                      name: "share",
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.makeAnonymous) = $event)),
                                      onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.makeAnonymous && _ctx.makeAnonymous(...args))),
                                      required: ""
                                    }, null, 544), [
                                      [_vModelCheckbox, _ctx.form.makeAnonymous]
                                    ]),
                                    _withDirectives(_createElementVNode("label", _hoisted_58, null, 512), [
                                      [_directive_translate, `form.makeAnonymous`]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                  _withDirectives(_createElementVNode("label", _hoisted_61, null, 512), [
                                    [_directive_translate, `form.first_name`]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "firstName",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.firstName) = $event)),
                                    disabled: _ctx.anonymous,
                                    placeholder: _ctx.firstName
                                  }, null, 8, _hoisted_62), [
                                    [_vModelText, _ctx.form.firstName]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "hidden",
                                    name: "lang",
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.lang) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.form.lang]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, [
                                  _withDirectives(_createElementVNode("label", _hoisted_66, null, 512), [
                                    [_directive_translate, `form.city`]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "city",
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.city) = $event)),
                                    placeholder: _ctx.city,
                                    required: ""
                                  }, null, 8, _hoisted_67), [
                                    [_vModelText, _ctx.form.city]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _withDirectives(_createElementVNode("label", _hoisted_70, null, 512), [
                                    [_directive_translate, `form.email`]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "email",
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.email) = $event)),
                                    placeholder: _ctx.email
                                  }, null, 8, _hoisted_71), [
                                    [_vModelText, _ctx.form.email]
                                  ]),
                                  _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.emailError), 1)
                                ])
                              ])
                            ]),
                            _withDirectives(_createElementVNode("p", null, null, 512), [
                              [_directive_translate, 
                    `testimonial.private_contact_information_message`
                  ]
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _withDirectives(_createElementVNode("h3", null, null, 512), [
                                [_directive_translate, `testimonial.make_public`]
                              ]),
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    id: "yes",
                                    name: "share",
                                    class: "screen-reader",
                                    required: "",
                                    value: true,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.public) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.public]
                                  ]),
                                  _withDirectives(_createElementVNode("label", _hoisted_76, null, 512), [
                                    [_directive_translate, `testimonial.legal_message`]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.publicError), 1)
                              ])
                            ]),
                            _createElementVNode("ul", _hoisted_78, [
                              _createElementVNode("li", null, [
                                _createElementVNode("div", _hoisted_79, [
                                  _withDirectives(_createElementVNode("p", null, null, 512), [
                                    [_directive_translate, `testimonial.consentement`]
                                  ])
                                ])
                              ]),
                              _createElementVNode("li", _hoisted_80, [
                                (!_ctx.isUploading)
                                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      role: "button",
                                      type: "button",
                                      class: "btn-big",
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.submit()))
                                    }, null, 512)), [
                                      [_directive_translate, `general.submit`]
                                    ])
                                  : _createCommentVNode("", true),
                                (_ctx.isUploading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                      _hoisted_82,
                                      _withDirectives(_createElementVNode("span", null, null, 512), [
                                        [_directive_translate, `general.submit_in_progress`]
                                      ])
                                    ], 512))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.step === 'confirmation')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _withDirectives(_createElementVNode("h2", null, null, 512), [
                                [_directive_translate, `testimonial.confirmation_title`]
                              ]),
                              _withDirectives(_createElementVNode("p", null, null, 512), [
                                [_directive_translate, `testimonial.confirmation_subtitle`]
                              ])
                            ]),
                            _createElementVNode("ul", _hoisted_85, [
                              _createElementVNode("li", _hoisted_86, [
                                _withDirectives(_createElementVNode("button", {
                                  type: "button",
                                  role: "button",
                                  class: "btn-big",
                                  title: _ctx.sendComplete,
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.finish()))
                                }, null, 8, _hoisted_87), [
                                  [_directive_translate, `testimonial.send_complete`]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}